// Include shared styles during development only
if (process.env.NODE_ENV !== 'production') {
  require('../assets/styles/styles.scss');
}
